import { get } from 'svelte/store';

export class Const {
    static readonly ASSIGNMENT_ADHOC = -1;
    static readonly ASSIGNMENT_UNSET = 0;
    static readonly WORK_DAY_DURATION_SECONDS = 8 * 3600;
    static readonly RELOAD_ADHOC_CHECKING_INTERVAL_SECONDS = 30;
    static readonly RELOAD_ROUTE_REALISATION_STATUS_INTERVAL_SECONDS = 10;
}

/*
                    ['id'=>'0','name'=>'dane niekompletne'],
                    ['id'=>'1','name'=>'dane kompletne'],
                    ['id'=>'2','name'=>'przydzielone'],
                    ['id'=>'3','name'=>'zaplanowane'],
                    ['id'=>'4','name'=>'zrealizowane'],
                    ['id'=>'-1','name'=>'(?) anulowane'],
                    ['id'=>'-2','name'=>'(?) wstrzymane']
 */
export const availableProcessStatuses = [
    {
        id: -2,
        name: '(?) wstrzymane',
    },
    {
        id: -1,
        name: '(?) anulowane',
    },
    {
        id: 0,
        name: 'incomplete_data',
        desc: 'incomplete_data',
    },
    {
        id: 1,
        name: 'to_assign', // do przydzielenia
        desc: 'complete_data',
    },
    {
        id: 2,
        name: 'to_approve', // do zatwierdzenia
        desc: 'assigned',
    },
    {
        id: 3,
        name: 'to_send', // do wysłania
        desc: 'approved',
    },
    {
        id: 4,
        name: 'in_progress', // w trakcie realizacji
        desc: 'sent',
    },
    {
        id: 5,
        name: 'in_delivery', // w dostawie (to jak mamy rozpoczętą trasę, albo potwierdzenie odbioru z magazynu, można docelowo podać tu aktualną ETA)
        desc: 'in_progress',
    },
    {
        id: 6,
        name: 'delivered', // dostarczone
        desc: 'completed',
    },
];

/*
może process_stage
0 - nieprzydzielony
10 - przydzielony / do zatwierdzenia
20 - zatwierdzony / do wysłania
50 - wysłany
60 - w realizacji
100 - zrealizowany
 */

export const availableProcessStages = [
    {
        id: 0,
        name: 'to_assign', // do przydzielenia
        desc: 'complete_data',
    },
    {
        id: 10,
        name: 'to_approve', // do zatwierdzenia
        desc: 'assigned',
    },
    {
        id: 20,
        name: 'to_send', // do wysłania
        desc: 'approved',
    },
    {
        id: 50,
        name: 'in_progress', // w trakcie realizacji
        desc: 'sent',
    },
    {
        id: 60,
        name: 'in_delivery', // w dostawie (to jak mamy rozpoczętą trasę, albo potwierdzenie odbioru z magazynu, można docelowo podać tu aktualną ETA)
        desc: 'in_progress',
    },
    {
        id: 100,
        name: 'delivered', // dostarczone
        desc: 'completed',
    },
];
